import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateSubmissionsCSV as CreateSubmissionsCSVMutation,
    CreateSubmissionsCSVVariables as CreateSubmissionsCSVVariables,
    SubmissionsCsvGenerateInput,
} from 'nutshell-graphql-types';

import CREATE_SUBMISSIONS_CSV from '../mutations/create-submissions-csv.graphql';

export const useCreateSubmissionsCSV = (): {
    createSubmissionsCSV: (arg1: SubmissionsCsvGenerateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createSubmissionsCSV, {loading, error}] = useMutation<
        CreateSubmissionsCSVMutation,
        CreateSubmissionsCSVVariables
    >(CREATE_SUBMISSIONS_CSV);

    return {
        createSubmissionsCSV: (input: SubmissionsCsvGenerateInput) =>
            createSubmissionsCSV({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
